import { reloadScripts } from "@helpers/utils";
import { CartData } from "@sections/cart";

const replacePersonalCansSection = (cart: CartData): void => {
  const isPersonalisedProductPage = document.querySelector(
    ".product__personalised",
  );
  console.warn("isPersonalisedProductPage", isPersonalisedProductPage);
  if (!isPersonalisedProductPage) {
    return;
  }

  const hasPersonalisedProduct = cart.items.some(
    (item) => item.properties._proof,
  );
  console.warn("hasPersonalisedProduct", hasPersonalisedProduct);

  const getMarkup = async () => {
    const section = await fetch(`?section_id=product-personalised`);
    const sectionString = await section.text();
    console.warn("SECTION String", sectionString);
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionString, "text/html");
    console.warn("DOC", doc);
    const oldSection = isPersonalisedProductPage?.parentElement?.parentElement;
    console.warn("oldSection", oldSection);
    const newSection = doc.querySelector(".product__personalised")
      ?.parentElement?.parentElement;
    console.warn("newSection", newSection);

    if (oldSection && newSection) {
      console.warn("REPLACING PC CANS SECTION");
      oldSection.innerHTML = newSection.innerHTML;
      console.warn("RELOADING SCRIPTS");
      reloadScripts(oldSection);
    }
  };

  if (isPersonalisedProductPage) {
    getMarkup();
  }
};

export default replacePersonalCansSection;
